import React from "react";
import { Link } from "react-router-dom";
import MyIcon from "./MyIcon";
import HelpButton from "../HelpContent/HelpButton";

export interface WhiteButtonProps {
  as: "RRLink" | "button" | "a" | "span";
  icon: any;
  heading: any;
  subheading: string;
  to?: string;
  onClick?: () => void;
  title?: string;
  target: string | undefined;
  disabled: boolean;
}

export default function WhiteButton({
  as,
  icon,
  heading,
  subheading,
  to = "",
  onClick = () => {},
  title = "",
  target,
  disabled,
}: WhiteButtonProps) {
  const As = disabled
    ? "span"
    : { RRLink: Link, button: "button", a: "a", span: "span" }[as];

  const Icon = icon;

  const generatedHelpKey =
    typeof heading === "string"
      ? (heading + (subheading ? "-" + subheading : ""))
          .toLowerCase?.()
          ?.replace(/\s+|\//g, "-") + "-button"
      : null;

  return (
    <span title={title} className="d-inline-block">
      <As
        className={`btn d-flex align-items-center btn-white rounded-3 py-3 ps-2 ${
          disabled ? "disabled" : ""
        }`}
        style={{ minWidth: 200 }}
        to={to}
        {...(as === "a" && { href: to, target })}
        onClick={onClick}
      >
        {Icon && <MyIcon Icon={Icon} width={20} className="mx-2" />}
        <div className="border-end border-tertiary mx-2 align-self-stretch" />
        <div className="text-start small">
          <h6 className="fw-bold mb-0">
            {heading}{" "}
            {generatedHelpKey && <HelpButton helpKey={generatedHelpKey} />}
          </h6>
          <span className="small opacity-50">{subheading}</span>
        </div>
      </As>
    </span>
  );
}
